import React from 'react'
import { SharedBetCardSkeleton } from './Components/SharedBetCardSkeleton'
import { HeaderSkeleton } from './Components/HeaderSkeleton'

interface SkeletonLoaderProps {
  showOnlyHeader?: boolean
  headerCount?: number
  cardCount?: number
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  showOnlyHeader = false,
  headerCount = 8,
  cardCount = 8,
}) =>
  showOnlyHeader
    ? Array.from({ length: headerCount }, (_, i) => <HeaderSkeleton isHeaderOnly key={i} />)
    : Array.from({ length: cardCount }, (_, i) => <SharedBetCardSkeleton key={i} />)
